/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnqueueBenchmarkRunRequest } from '../../models/enqueue-benchmark-run-request';
import { EnqueueBenchmarkRunResult } from '../../models/enqueue-benchmark-run-result';

export interface ApiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost$Params {
  benchmarkId: string;
  modelVersionId: string;
      body?: EnqueueBenchmarkRunRequest
}

export function apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost(http: HttpClient, rootUrl: string, params: ApiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EnqueueBenchmarkRunResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost.PATH, 'post');
  if (params) {
    rb.path('benchmarkId', params.benchmarkId, {});
    rb.path('modelVersionId', params.modelVersionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnqueueBenchmarkRunResult>;
    })
  );
}

apiAdminBenchmarksBenchmarkIdRunsModelVersionIdPost.PATH = '/api/Admin/benchmarks/{benchmarkId}/runs/{modelVersionId}';
